/**
 * MiniCRM Service for handling form submissions to MiniCRM API
 */

// Map form IDs to registration types - Simplified to 4 types from FORM.md
const FORM_REGISTRATION_TYPES = {
    'footer-contact': 'Ajánlatkérő form',         // Footer = Offer Request Form (3447)
    'sticky-button-offer': 'Ajánlatkérés',       // Sticky = Green side bar (3448)
    'custom-offer': 'Egyedi ajánlatkérés',       // Custom = Custom Offer Request (3448)
    'email-request': 'Ajánlat emailben',         // Email = Offer via Email (3449)
};

/**
 * Submit form data to MiniCRM
 * @param {string} formId - The form identifier
 * @param {Object} formData - The form data to submit
 * @param {Object} options - Additional options
 * @returns {Promise<Object>} - Response from MiniCRM API
 */
export async function submitToMiniCrm(formId, formData, options = {}) {
    try {
        // Get registration type based on form ID
        const registrationType = FORM_REGISTRATION_TYPES[formId] || 'Oldalsáv';
        
        // Prepare payload for MiniCRM API
        const payload = {
            form_id: formId,  // Send the form ID that backend expects
            company_name: formData.company_name || formData.name || '',
            first_name: formData.first_name || formData.forename || '',
            last_name: formData.last_name || formData.surname || '',
            email: formData.email || '',
            phone: formData.phone || '',
            message: formData.message || '',
            url: window.location.href,
            gdpr: formData.gdpr || formData.terms || false
        };

        // Submit to MiniCRM API using XMLHttpRequest wrapped in Promise
        const result = await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            
            xhr.open('POST', '/api/minicrm-submit', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '');
            xhr.setRequestHeader('Accept', 'application/json');
            
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        
                        if (xhr.status >= 200 && xhr.status < 300 && response.status === 'success') {
                            resolve({
                                success: true,
                                message: response.message || 'Successfully submitted to MiniCRM'
                            });
                        } else {
                            resolve({
                                success: false,
                                message: response.message || 'Failed to submit to MiniCRM'
                            });
                        }
                    } catch (parseError) {
                        resolve({
                            success: false,
                            message: 'Invalid response from MiniCRM'
                        });
                    }
                }
            };
            
            xhr.onerror = function() {
                resolve({
                    success: false,
                    message: 'Network error while submitting to MiniCRM'
                });
            };
            
            xhr.send(JSON.stringify(payload));
        });

        return {
            status: 'fulfilled',
            value: result
        };

    } catch (error) {
        return {
            status: 'fulfilled',
            value: {
                success: false,
                message: 'Error preparing MiniCRM request'
            }
        };
    }
}

export default {
    submitToMiniCrm
}; 